import { render, staticRenderFns } from "./ArchivePage.vue?vue&type=template&id=4b4f5f46&scoped=true&"
import script from "./ArchivePage.vue?vue&type=script&lang=js&"
export * from "./ArchivePage.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePage.vue?vue&type=style&index=0&id=4b4f5f46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f5f46",
  null
  
)

export default component.exports